import React from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider,
  ListSubheader,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";

import { api } from "../../../Services/Api";
import {
  startLoading,
  stopLoading,
} from "../../../Store/Modules/Store/Actions";

import { loadMenu } from "../../../Store/Modules/Menu/Actions";

function ListCategoryTemplates({ onClickNew, onClose }) {
  const dispatch = useDispatch();
  const categoryTemplates = useSelector(
    (state) => state.store.categoryTemplates
  );

  function handleAddTemplate(templateId) {
    dispatch(startLoading());
    api
      .post("/menu/categories/from-template/" + templateId)
      .then(({ data }) => {
        setTimeout(() => {
          dispatch(loadMenu());
          dispatch(stopLoading());
        }, 2000);
      })
      .catch((err) => {
        console.log(err);
        dispatch(stopLoading());
      })
      .finally(() => {
        onClose();
      }); //TODO
  }
  console.log(categoryTemplates)

  return (
    <Box>
      <List>
        <ListItem divider button onClick={onClickNew}>
          <ListItemText primary="Nova Categoria" />
        </ListItem>
        <ListSubheader>templates</ListSubheader>
        {categoryTemplates.map((temp) => (
          <ListItem divider button onClick={() => handleAddTemplate(temp.id)}>
            <ListItemText primary={temp.description} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}

export default ListCategoryTemplates;
